import * as React from 'react';
import { baseClassAnd, ClassableProps } from '@jcharlesworthuk/your-mum-core/dist/functions';
import { useRef, useEffect } from 'react';

const baseClass = 'screen-demo';

type Props = ClassableProps & {
    animate: boolean;
};

const WeeklyReportScreenDemo: React.FunctionComponent<Props> = props => {
    const objectRef = useRef<HTMLObjectElement>(null);

    useEffect(() => {
        if (props.animate && objectRef.current && objectRef.current.contentDocument && isLoaded(objectRef.current.contentDocument)) {
            animateDomElement(objectRef.current.contentDocument);
        } 
    }, [props.animate]);

    return <object width="100%" 
                className={baseClassAnd(baseClass, props)} 
                id="weekly-reports-svg" 
                data="/screen-demos/weekly-reports.svg" 
                ref={objectRef} />
}

export default WeeklyReportScreenDemo;

function isLoaded(svg: Document) {
    return !!svg.getElementById("likert-group-1");
}

export function animateDomElement(svg: Document) {
    const likertGroups = [
        svg.getElementById("likert-group-1"),
        svg.getElementById("likert-group-2"),
        svg.getElementById("likert-group-3"),
        svg.getElementById("likert-group-4"),
    ]

    for (let i = 0; i < likertGroups.length; i++) {
        likertGroups[i].style.transform = 'scale(0,1)';
        likertGroups[i].style.transformOrigin = '114px 100%';
    }
   
    function animateLikert() {
        for (let i = 0; i < likertGroups.length; i++) {
            setTimeout(() => {
                likertGroups[i].style.transition = 'transform 250ms ease-out';
                likertGroups[i].style.transform = 'scale(1,1)';
            }, i * 250);
        }
    }
    setTimeout(animateLikert, 100);
}